"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const msal_react_1 = require("@azure/msal-react");
const Header_1 = __importDefault(require("@/components/Header"));
const Page_1 = __importDefault(require("@/components/Page"));
const route_1 = require("@/utilities/route");
const Login_1 = __importDefault(require("@/pages/Login"));
const routes_1 = __importDefault(require("@/constants/routes"));
const Feedback_1 = __importDefault(require("@/pages/Feedback"));
const App = () => {
    const nestedRoutes = (0, route_1.generateAppRoutes)(routes_1.default);
    const { inProgress } = (0, msal_react_1.useMsal)();
    const isAuthenticated = (0, msal_react_1.useIsAuthenticated)();
    if (inProgress !== "none") {
        return react_1.default.createElement(Feedback_1.default, { feedback: inProgress });
    }
    if (!isAuthenticated) {
        return react_1.default.createElement(Login_1.default, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(msal_react_1.AuthenticatedTemplate, null,
            react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                react_1.default.createElement(Header_1.default, null),
                react_1.default.createElement(react_router_dom_1.Switch, null, nestedRoutes.map((route) => (react_1.default.createElement(react_router_dom_1.Route, { key: route.path, path: route.path, exact: route.path === "/" },
                    react_1.default.createElement(Page_1.default, { route: route }))))))),
        react_1.default.createElement(msal_react_1.UnauthenticatedTemplate, null,
            react_1.default.createElement(Login_1.default, null))));
};
exports.default = App;
